const DAY_MS = 1000 * 60 * 60 * 24;
const TRIAL_DAYS = 10;

const toDate = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value.toDate === "function") {
    const converted = value.toDate();
    return Number.isFinite(converted?.getTime?.()) ? converted : null;
  }

  const parsedDate = value instanceof Date ? value : new Date(value);
  return Number.isFinite(parsedDate.getTime()) ? parsedDate : null;
};

export const resolveTrialCountdownState = ({
  trialStartDate,
  trialOverrideEndAt,
  now = new Date(),
  trialDays = TRIAL_DAYS,
} = {}) => {
  const normalizedStartDate = toDate(trialStartDate);
  const normalizedNow = toDate(now);

  if (!normalizedStartDate || !normalizedNow) {
    return null;
  }

  const normalizedOverrideEndAt = toDate(trialOverrideEndAt);
  const shouldUseOverrideEndAt =
    normalizedOverrideEndAt &&
    normalizedNow.getTime() <= normalizedOverrideEndAt.getTime();
  const trialEndDate = shouldUseOverrideEndAt
    ? new Date(normalizedOverrideEndAt.getTime())
    : new Date(normalizedStartDate.getTime());

  if (!shouldUseOverrideEndAt) {
    trialEndDate.setDate(trialEndDate.getDate() + trialDays);
  }

  const totalDuration = trialEndDate.getTime() - normalizedStartDate.getTime();
  if (totalDuration <= 0) {
    return {
      daysLeft: 0,
      percentageFilled: 100,
      trialEndTimestamp: trialEndDate.getTime(),
    };
  }

  const elapsed = normalizedNow.getTime() - normalizedStartDate.getTime();
  const remaining = trialEndDate.getTime() - normalizedNow.getTime();

  return {
    daysLeft: Math.max(Math.ceil(remaining / DAY_MS), 0),
    percentageFilled: Math.min(Math.max((elapsed / totalDuration) * 100, 0), 100),
    trialEndTimestamp: trialEndDate.getTime(),
  };
};
